import React, { useState, useEffect } from 'react';
import DataTable from '../../../../Common/DataTable/DataTable';
import api, { RBAC_BASE } from '../../../../api/rbacApi';
import { Link } from 'react-router-dom';

const RoleCreateTable = () => {
  const [dataT, setDataT] = useState([]);
  const [editRow, setEditRow] = useState(null);
  const [newRole, setNewRole] = useState({
    nvchDesigName: "",
    nvchAliasName: "",
    bitStatus: true
  });

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const res = await api.get(`${RBAC_BASE}/roles`);
    setDataT(res.data);
  };

  const handleCreate = async () => {
    if (!newRole.nvchDesigName) {
      alert("Role name is required");
      return;
    }

    const exists = dataT.some(
      r =>
        r.nvchDesigName.toLowerCase().trim() ===
        newRole.nvchDesigName.toLowerCase().trim()
    );

    if (exists) {
      alert("Role already exists");
      return;
    }

    try {
      await api.post(`${RBAC_BASE}/roles`, {
        name: newRole.nvchDesigName,
        alias: newRole.nvchAliasName,
        status: newRole.bitStatus
      });

      alert("Role created successfully");

      setNewRole({
        nvchDesigName: "",
        nvchAliasName: "",
        bitStatus: true
      });

      load();

    } catch (err) {
      console.error(err);

      const msg =
        err.response?.data?.message ||
        "Failed to create role";

      alert(`${msg}`);
    }
  };

  const handleChange = (id, field, value) => {
    setDataT(prev =>
      prev.map(row =>
        row.intDesigId === id
          ? { ...row, [field]: value }
          : row
      )
    );
  };

  // SAVE UPDATE
  const handleSave = async (row) => {
    try {
      await api.put(`${RBAC_BASE}/roles/${row.intDesigId}`, {
        name: row.nvchDesigName,
        alias: row.nvchAliasName,
        status: row.bitStatus
      });

      setEditRow(null);
      load();

    } catch (err) {
      console.error(err);
      alert("Update failed");
    }
  };

  const columns = [
    { Header: 'ID', accessor: 'id' },

    {
      Header: 'Role Name',
      Cell: ({ row }) => {
        const data = row.original;
        const isEditing = editRow === data.intDesigId;

        return isEditing ? (
          <input
            className="form-control"
            value={data.nvchDesigName}
            onChange={(e) =>
              handleChange(data.intDesigId, "nvchDesigName", e.target.value)
            }
          />
        ) : (
          data.nvchDesigName
        );
      }
    },

    {
      Header: 'Alias',
      Cell: ({ row }) => {
        const data = row.original;
        const isEditing = editRow === data.intDesigId;

        return isEditing ? (
          <input
            className="form-control"
            value={data.nvchAliasName}
            onChange={(e) =>
              handleChange(data.intDesigId, "nvchAliasName", e.target.value)
            }
          />
        ) : (
          data.nvchAliasName
        );
      }
    },

    {
      Header: 'Action',
      Cell: ({ row }) => {
        const data = row.original;
        const isEditing = editRow === data.intDesigId;

        return isEditing ? (
          <>
            <button
              className="btn btn-sm btn-success me-2"
              onClick={() => handleSave(data)}
            >
              Save
            </button>

            <button
              className="btn btn-sm btn-light"
              onClick={() => setEditRow(null)}
            >
              Cancel
            </button>
          </>
        ) : (
          <>
            <button
              className="btn btn-sm btn-outline-primary me-2"
              onClick={() => setEditRow(data.intDesigId)}
            >
              Edit
            </button>
          </>
        );
      }
    },

    {
      Header: 'Status',
      Cell: ({ row }) => {
        const data = row.original;

        return (
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              checked={data.bitStatus}
              onChange={async (e) => {
                const newStatus = e.target.checked;

                handleChange(data.intDesigId, "bitStatus", newStatus);

                try {
                  await api.put(`${RBAC_BASE}/roles/${data.intDesigId}`, {
                    name: data.nvchDesigName,
                    alias: data.nvchAliasName,
                    status: newStatus
                  });

                  alert(`Role ${newStatus ? "activated" : "deactivated"} successfully`);

                } catch (err) {
                  console.error(err);
                  alert("Status update failed");

                  handleChange(data.intDesigId, "bitStatus", !newStatus);
                }
              }}
            />
          </div>
        );
      }
    },

    {
      Header: 'Permissions',
      Cell: ({ row }) => {
        const data = row.original;

        return (
          <Link
            to={`/role-permission/${data.intDesigId}`}
            state={{ roleName: data.nvchDesigName }}
            className="btn btn-sm btn-outline-secondary"
          >
            Manage
          </Link>
        );
      }
    }
  ];

  const formattedData = dataT.map((data) => ({
    ...data,
    id: data.intDesigId
  }));

  return (
    <div className="admin-role-list-page">
      <div className="card admin-surface-card mb-4">
        <div className="card-header admin-surface-header">
          <h5 className="card-title mb-0">Create New Role</h5>
        </div>
        <div className="card-body admin-surface-body">
          <div className="row g-3 align-items-end">
            <div className="col-lg-4 col-md-6">
              <label className="form-label fw-semibold">Role Name</label>
              <input
                className="form-control"
                placeholder="Role Name"
                value={newRole.nvchDesigName}
                onChange={(e) =>
                  setNewRole({ ...newRole, nvchDesigName: e.target.value })
                }
              />
            </div>

            <div className="col-lg-4 col-md-6">
              <label className="form-label fw-semibold">Alias</label>
              <input
                className="form-control"
                placeholder="Alias"
                value={newRole.nvchAliasName}
                onChange={(e) =>
                  setNewRole({ ...newRole, nvchAliasName: e.target.value })
                }
              />
            </div>

            <div className="col-lg-2 col-md-4">
              <div className="form-check form-switch mt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={newRole.bitStatus}
                  onChange={(e) =>
                    setNewRole({ ...newRole, bitStatus: e.target.checked })
                  }
                />
                <label className="form-check-label small">Active</label>
              </div>
            </div>

            <div className="col-lg-2 col-md-4 d-grid">
              <button className="btn btn-primary" onClick={handleCreate}>
                Add
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="admin-table-shell">
        <DataTable columns={columns} data={formattedData} />
      </div>
    </div>
  );
};

export default RoleCreateTable;
